import { Environment } from 'types';
import { TokenKey } from './types';

export const DEFAULT_ENVIRONMENT: Environment = 'dev';

export const TOKEN_KEYS: Record<Environment, TokenKey> = {
  dev: 'td',
  local: 'tl',
  prod: 'tp',
};
